
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 6H7a2 2 0 00-2 2v16a2 2 0 002 2h5a2 2 0 002-2V8a2 2 0 00-2-2zm13 0h-5a2 2 0 00-2 2v16a2 2 0 002 2h5a2 2 0 002-2V8a2 2 0 00-2-2z"}})])
          )
        }
      }
    